export default __webpack_public_path__ + "static/ai_image-29519129755a7ce71c4fe8f5223edcb7.jpg";